module.exports = __webpack_public_path__ + "img/3_02.d97d9892.jpg";